/**
 * A failed assistant turn stays in the chat as a bubble with Retry.
 * The message never includes the question, the photo, or a stack.
 */

const { CONNECTION_FAILURE_MESSAGE } = require('./connectionCopy');

function assistantFailureCopy(input) {
  const source = input || {};
  const status = Number(source.status) || 0;
  let server = String(source.serverError || '').replace(/\s+/g, ' ').trim();
  if (/^no answer\b/i.test(server)) server = '';
  const safeServer = server && server.length <= 700 && !/\b(sql|exception|syntaxerror)\b/i.test(server);
  if (status === 401 || status === 403) {
    return 'Please sign in again, then tap Retry.';
  }
  if (!status && (!safeServer || /failed to fetch|network|load failed|timeout|couldn't connect/i.test(server))) {
    return CONNECTION_FAILURE_MESSAGE;
  }
  if (safeServer) {
    return /tap retry/i.test(server) ? server : `${server.replace(/[.!?]$/, '')}. Tap Retry.`;
  }
  return "I couldn't answer that just now. Tap Retry.";
}

function messagesBeforeSend(messages, retry) {
  const list = Array.isArray(messages) ? messages : [];
  const withoutError = retry ? list.filter((msg) => msg.id !== retry.id) : list.slice();
  if (!retry) return withoutError;
  for (let index = withoutError.length - 1; index >= 0; index -= 1) {
    const msg = withoutError[index];
    if (msg && msg.role === 'user' && msg.content === retry.retryQuestion) {
      return withoutError.slice(0, index).concat(withoutError.slice(index + 1));
    }
  }
  return withoutError;
}

function assistantErrorMessage(input) {
  const source = input || {};
  return {
    role: 'assistant',
    error: true,
    id: `assistant-error-${Date.now()}-${Math.random().toString(16).slice(2)}`,
    content: assistantFailureCopy(source),
    retryQuestion: String(source.question || ''),
    retryImage: source.image || null,
    retryImageUrl: source.imageUrl || '',
    where: source.where || 'assistant',
    timestamp: new Date(),
  };
}

async function readAssistantJson(response) {
  let text = '';
  try {
    text = await response.text();
  } catch (error) {
    text = '';
  }
  let body = {};
  if (text) {
    try {
      const parsed = JSON.parse(text);
      if (parsed && typeof parsed === 'object') body = parsed;
    } catch (error) {
      body = {};
    }
  }
  return {
    ok: Boolean(response && response.ok),
    status: response && response.status ? response.status : 0,
    body,
  };
}

module.exports = {
  assistantFailureCopy,
  assistantErrorMessage,
  messagesBeforeSend,
  readAssistantJson,
};
